import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="max-w-lg mx-auto px-6 pt-32 pb-24 text-center">
      <Compass size={44} className="text-elec mx-auto moe-float" strokeWidth={1.4}/>
      <h1 className="mt-4 text-5xl font-bold tracking-tight">Off the map.</h1>
      <p className="mt-2 text-sm text-muted">This route does not exist.</p>
      <Link to="/" className="mt-6 inline-flex moe-btn moe-btn-primary">Back home</Link>
    </div>
  );
}
